module.exports = __webpack_public_path__ + "static/media/logo.01cbf2f2.svg";